<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-payroll-cycles-dialog-create
          v-if="$hasPermissionTo(['create payroll cycles'])"
          @created="loadPayrollCycles"
        /> 
      </v-col>

      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Payroll Cycle's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in payroll cycle here"
          append-icon="search"
          label="Search Payroll Cycle"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredPayrollCycles"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.include_basic_salary="{ item }">
        <div>
          <v-icon medium>
            {{ item.include_basic_salary ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
          </v-icon>

          <div
            v-if="item.include_basic_salary"
            class="font-weight-bold"
          >
            {{ item.start_period }}({{ item.start_day }}) to {{ item.end_period }}({{ item.end_day }})
          </div>
        </div>
      </template>

      <template v-slot:item.description="{ item }">
        <div v-html="item.description" />
      </template>

      <template v-slot:item.include_tp_one="{ item }">
        <div>
          <v-icon medium>
            {{ item.include_tp_one ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
          </v-icon>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-payroll-payroll-cycles-dialog-edit
            v-if="$hasPermissionTo(['update payroll cycles'])"
            :payroll-cycle="item"
            @updated="refreshData"
          />
          <span class="mx-1" />
          <!-- <setup-payroll-payroll-cycles-dialog-delete
            v-if="$hasPermissionTo(['delete payroll cycles']) && $vuetify.breakpoint.mdAndUp"
            :payroll-cycle="item"
            @deleted="refreshData"
          />
          <setup-payroll-payroll-cycles-dialog-delete-mobile
            v-if="$hasPermissionTo(['delete payroll cycles']) && $vuetify.breakpoint.smAndDown"
            :payroll-cycle="item"
            @deleted="refreshData"
          /> -->
        </span>
        <span v-else>
          <setup-payroll-payroll-cycles-dialog-restore
            v-if="$hasPermissionTo(['restore payroll cycles']) && $vuetify.breakpoint.mdAndUp"
            :payroll-cycle="item"
            @restored="refreshData"
          />
          <setup-payroll-payroll-cycles-dialog-restore-mobile
            v-if="$hasPermissionTo(['restore payroll cycles']) && $vuetify.breakpoint.smAndDown"
            :payroll-cycle="item"
            @restored="refreshData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollPayrollCyclesDialogCreate: () => import('@/components/hris/setup/payroll/payroll-cycle/DialogCreate'),
      SetupPayrollPayrollCyclesDialogEdit: () => import('@/components/hris/setup/payroll/payroll-cycle/DialogEdit'),
      // SetupPayrollPayrollCyclesDialogDelete: () => import('@/components/hris/setup/payroll/payroll-cycle/DialogDelete'),
      // SetupPayrollPayrollCyclesDialogDeleteMobile: () => import('@/components/hris/setup/payroll/payroll-cycle/DialogDeleteMobile'),
      SetupPayrollPayrollCyclesDialogRestore: () => import('@/components/hris/setup/payroll/payroll-cycle/DialogRestore'),
      SetupPayrollPayrollCyclesDialogRestoreMobile: () => import('@/components/hris/setup/payroll/payroll-cycle/DialogRestoreMobile'),
    },
    data () {
      return {
        payrollCycles: [],
        trashedPayrollCycles: [],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: 'Include Basic Salary?',
            align: 'center',
            value: 'include_basic_salary',
          },
          {
            text: 'Include Additional Deduction (TP1)?',
            align: 'center',
            value: 'include_tp_one',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredPayrollCycles () {
        return this.statusFilter ? this.payrollCycles : this.trashedPayrollCycles
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadPayrollCycles () {
        this.$api.hrisPayrollCycles().list()
          .then(response => {
            this.payrollCycles = response.data
            this.tableLoading = false
          })
      },
      loadTrashedPayrollCycles () {
        this.$api.hrisPayrollCycles().listTrashed()
          .then(response => {
            this.trashedPayrollCycles = response.data
          })
      },
      refreshData () {
        this.loadPayrollCycles()
        this.loadTrashedPayrollCycles()
      },
    },
  }
</script>

<style scoped>
.font-calibri{
    font-family: Calibri !important;
}

.font-16{
    font-size:16px;
}

.border-bottom-light-grey{
    border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
    max-height: 36px !important;
}

.border{
    border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
    padding-left:0px
}
</style>
